(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('m-iwt-slider')) {
  customElements.define('m-iwt-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = Array.from(this.querySelectorAll('.m-iwt-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.visible = false;
      this.hovering = false;
      this.focused = false;
      this.editorSelected = false;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reducedMotion.matches;
      this.rotationButton = this.querySelector('[data-rotation]');
      this.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (!video) return;
        ['play', 'pause', 'ended'].forEach((name) => {
          video.addEventListener(name, () => {
            slide.dataset.playing = String(!video.paused && !video.ended);
            this.updateRotationButton();
          }, { signal });
        });
      });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-slide')) this.show(Number(button.dataset.slide), true);
        if (button.hasAttribute('data-step')) this.show(this.index + Number(button.dataset.step), true);
        if (button.hasAttribute('data-rotation')) {
          this.toggleVideo();
        }
        if (button.classList.contains('m-iwt-slider__play')) {
          this.mountEmbed(this.slides[this.index], true);
        }
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.target.closest('video, iframe, input, textarea, select, a, [contenteditable]')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, { signal });
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovering = true;
        this.schedule();
      }, { signal });
      this.addEventListener('pointerleave', () => {
        this.hovering = false;
        this.schedule();
      }, { signal });
      this.addEventListener('focusin', () => {
        this.focused = true;
        this.schedule();
      }, { signal });
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, { signal });
      this.addEventListener('touchstart', (event) => {
        this.touchStart = null;
        if (event.target.closest('video, iframe, button') || event.touches.length !== 1) return;
        this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { signal, passive: true });
      this.addEventListener('touchend', (event) => {
        if (!this.touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.show(this.index + (dx < 0 ? 1 : -1), true);
        }
      }, { signal, passive: true });
      this.addEventListener('touchcancel', () => { this.touchStart = null; }, { signal });
      document.addEventListener('visibilitychange', () => this.syncVisibility(), { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.editorSelected = true;
        this.show(index, false);
      }, { signal });
      document.addEventListener('shopify:block:deselect', (event) => {
        if (!this.slides.some((slide) => slide.dataset.blockId === event.detail.blockId)) return;
        this.editorSelected = false;
        this.schedule();
      }, { signal });
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) {
          this.paused = true;
          this.stopMedia(this.slides[this.index]);
          const video = this.slides[this.index]?.querySelector('video');
          if (video && !this.hasVideoToggle(this.slides[this.index])) video.controls = true;
        }
        this.updateRotationButton();
        this.schedule();
      }, { signal });
      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.syncVisibility();
      }, { threshold: 0 });
      this.observer.observe(this);
      this.show(0, false);
      this.updateRotationButton();
    }

    show(index, announce) {
      if (!this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      const oldSlide = this.slides[this.index];
      if (next !== this.index && oldSlide.contains(document.activeElement)) this.focus({ preventScroll: true });
      this.slides.forEach((slide, position) => {
        const active = position === next;
        if (!active) this.stopMedia(slide);
        slide.hidden = !active;
        slide.inert = !active;
      });
      this.index = next;
      this.dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === next)));
      if (announce) {
        const status = this.querySelector('[data-status]');
        if (status) status.textContent = this.slides[next].getAttribute('aria-label');
      }
      this.startMedia(this.slides[next]);
      this.updateRotationButton();
      this.schedule();
    }

    mountEmbed(slide, autoplay) {
      const embed = slide.querySelector('.m-iwt-slider__embed');
      if (!embed || embed.querySelector('iframe')) return;
      const template = embed.querySelector('template');
      if (!template) return;
      const iframe = template.content.firstElementChild.cloneNode(true);
      const url = new URL(iframe.dataset.src);
      url.searchParams.set('autoplay', autoplay ? '1' : '0');
      if (url.hostname === 'www.youtube.com') {
        url.searchParams.set('enablejsapi', '1');
        url.searchParams.set('origin', window.location.origin);
      }
      iframe.src = url.href;
      slide.iwtDesiredPlaying = autoplay;
      slide.dataset.playing = String(autoplay);
      embed.appendChild(iframe);
      const play = embed.querySelector('.m-iwt-slider__play');
      const wasFocused = document.activeElement === play;
      play.hidden = true;
      if (wasFocused) iframe.focus({ preventScroll: true });
      if (this.hasVideoToggle(slide)) this.connectPlayer(slide, iframe, url.hostname);
      this.updateRotationButton();
    }

    startMedia(slide) {
      if (!slide || !this.visible || document.hidden) return;
      const autoplay = slide.dataset.autoplay === 'true' && !this.reducedMotion.matches && !window.Shopify?.designMode;
      const video = slide.querySelector('video');
      if (!autoplay) {
        if (video && slide.dataset.autoplay === 'true' && !this.hasVideoToggle(slide)) video.controls = true;
        return;
      }
      if (slide.dataset.userPaused === 'true') return;
      if (video && !video.dataset.iwtStarted) {
        video.dataset.iwtStarted = 'true';
        video.muted = true;
        this.playNative(slide, video);
      }
      this.mountEmbed(slide, true);
    }

    stopMedia(slide) {
      if (!slide) return;
      const video = slide.querySelector('video');
      if (video) {
        video.pause();
        delete video.dataset.iwtStarted;
      }
      const iframe = slide.querySelector('iframe');
      slide.iwtDesiredPlaying = false;
      slide.dataset.playing = 'false';
      if (slide.iwtPlayer) {
        try {
          const destroyed = slide.iwtPlayer.destroy();
          if (destroyed?.catch) destroyed.catch(() => {});
        } catch (error) {}
        slide.iwtPlayer = null;
      }
      if (iframe) iframe.remove();
      const play = slide.querySelector('.m-iwt-slider__play');
      if (play) play.hidden = false;
      this.updateRotationButton();
    }

    syncVisibility() {
      if (!this.visible || document.hidden) this.stopMedia(this.slides[this.index]);
      else this.startMedia(this.slides[this.index]);
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autorotate !== 'true' || this.slides.length < 2 || this.paused || this.slides[this.index]?.dataset.userPaused === 'true' || this.hovering || this.focused || this.editorSelected || !this.visible || document.hidden || window.Shopify?.designMode) return;
      this.timer = setTimeout(() => this.show(this.index + 1, false), Math.max(3000, Number(this.dataset.interval) || 5000));
    }

    updateRotationButton() {
      if (!this.rotationButton) return;
      const slide = this.slides[this.index];
      if (!this.hasVideoToggle(slide) && document.activeElement === this.rotationButton) this.focus({ preventScroll: true });
      this.rotationButton.hidden = !this.hasVideoToggle(slide);
      const playing = slide?.dataset.playing === 'true';
      this.rotationButton.setAttribute('aria-label', playing ? this.rotationButton.dataset.pauseLabel : this.rotationButton.dataset.playLabel);
      if (slide) this.rotationButton.setAttribute('aria-controls', slide.id);
      this.rotationButton.querySelector('[data-pause-icon]').hidden = !playing;
      this.rotationButton.querySelector('[data-play-icon]').hidden = playing;
    }

    hasVideoToggle(slide) {
      return !!slide && slide.dataset.autoplay === 'true' && slide.dataset.controlsHidden === 'true' && !!slide.querySelector('video, .m-iwt-slider__embed');
    }

    playNative(slide, video) {
      const request = video.play();
      if (request?.catch) request.catch(() => {
        slide.dataset.playing = 'false';
        if (!this.hasVideoToggle(slide)) video.controls = true;
        this.updateRotationButton();
      });
    }

    toggleVideo() {
      const slide = this.slides[this.index];
      if (!this.hasVideoToggle(slide)) return;
      const video = slide.querySelector('video');
      const playing = video ? !video.paused && !video.ended : slide.iwtDesiredPlaying === true;
      slide.dataset.userPaused = String(playing);
      slide.iwtDesiredPlaying = !playing;
      this.schedule();
      if (video) {
        if (playing) video.pause();
        else this.playNative(slide, video);
      } else if (!slide.querySelector('iframe')) {
        this.mountEmbed(slide, true);
      } else {
        this.applyPlayerState(slide);
      }
      this.updateRotationButton();
    }

    static loadPlayerAPI(provider) {
      const ready = () => provider === 'youtube' ? window.YT?.Player : window.Vimeo?.Player;
      if (ready()) return Promise.resolve();
      this.playerAPIs ||= {};
      if (this.playerAPIs[provider]) return this.playerAPIs[provider];
      this.playerAPIs[provider] = new Promise((resolve, reject) => {
        const url = provider === 'youtube' ? 'https://www.youtube.com/iframe_api' : 'https://player.vimeo.com/api/player.js';
        let script = Array.from(document.scripts).find((item) => item.src === url);
        const started = Date.now();
        let timer;
        const check = () => {
          if (ready()) { clearInterval(timer); resolve(); }
          else if (Date.now() - started > 15000) { clearInterval(timer); reject(new Error('Video player API unavailable')); }
        };
        timer = setInterval(check, 100);
        if (!script) {
          script = document.createElement('script');
          script.src = url;
          script.async = true;
          script.addEventListener('error', () => { clearInterval(timer); reject(new Error('Video player API unavailable')); }, { once: true });
          document.head.appendChild(script);
        }
        check();
      }).catch((error) => { delete this.playerAPIs[provider]; throw error; });
      return this.playerAPIs[provider];
    }

    async connectPlayer(slide, iframe, hostname) {
      const provider = hostname === 'www.youtube.com' ? 'youtube' : 'vimeo';
      const current = () => this.isConnected && slide.querySelector('iframe') === iframe;
      const update = (playing) => {
        if (!current()) return;
        slide.dataset.playing = String(playing);
        slide.iwtDesiredPlaying = playing;
        this.updateRotationButton();
      };
      try {
        await this.constructor.loadPlayerAPI(provider);
        if (!current()) return;
        if (provider === 'youtube') {
          new window.YT.Player(iframe, {
            events: {
              onReady: (event) => {
                if (!current()) { event.target.destroy(); return; }
                slide.iwtPlayer = event.target;
                this.applyPlayerState(slide);
              },
              onStateChange: (event) => {
                if ([0, 1, 2, 3].includes(event.data)) update(event.data === 1 || event.data === 3);
              },
              onAutoplayBlocked: () => { slide.iwtDesiredPlaying = false; update(false); }
            }
          });
        } else {
          const player = new window.Vimeo.Player(iframe);
          slide.iwtPlayer = player;
          player.on('play', () => update(true));
          player.on('pause', () => update(false));
          player.on('ended', () => { slide.iwtDesiredPlaying = false; update(false); });
          await player.ready();
          if (current()) this.applyPlayerState(slide);
        }
      } catch (error) {
        if (!current()) return;
        const url = new URL(iframe.src);
        url.searchParams.set('controls', '1');
        iframe.src = url.href;
        slide.dataset.controlsHidden = 'false';
        this.updateRotationButton();
      }
    }

    applyPlayerState(slide) {
      const player = slide.iwtPlayer;
      if (!player) {
        slide.dataset.playing = String(slide.iwtDesiredPlaying);
        this.updateRotationButton();
        return;
      }
      const playing = slide.iwtDesiredPlaying;
      if (typeof player.playVideo === 'function') {
        if (playing) player.playVideo();
        else player.pauseVideo();
      } else {
        const request = playing ? player.play() : player.pause();
        if (request?.catch) request.catch(() => {
          slide.iwtDesiredPlaying = false;
          slide.dataset.playing = 'false';
          this.updateRotationButton();
        });
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.slides?.forEach((slide) => this.stopMedia(slide));
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
